import { RequestOpenFormTypes } from '$shared/constants/global';
import { EntityParameterType } from '$shared/constants/EntityParameterType';
import type { IEntityParameter } from '$shared/interfaces/api/IEntityParameter';
import { EntityParam } from './EntityParam';

export default class DatasetScanParam extends EntityParam {
  public readonly dataset: string | undefined;
  public aliasValue: DataListValue;

  constructor(param: IEntityParameter, dataset?: string) {
    super(param);
    this.dataset = dataset;
  }

  get value(): string {
    if (this.type === EntityParameterType.FacilityName) {
      return this.data.name || '';
    }
    return super.value;
  }

  static find(type: EntityParameterType, params: DatasetScanParam[]): DatasetScanParam {
    return params?.find((param) => param.type === type);
  }

  static filter(type: EntityParameterType, params: DatasetScanParam[]): DatasetScanParam[] {
    return params?.filter((param) => param.type === type) || [];
  }

  static getFormType(param: EntityParameterType): string {
    switch (param) {
      case EntityParameterType.ProviderLicense: {
        return RequestOpenFormTypes.NewLicense;
      }
      case EntityParameterType.ProviderNpi: {
        return RequestOpenFormTypes.NewNpi;
      }
      case EntityParameterType.ProviderEducation: {
        return RequestOpenFormTypes.NewEducation;
      }

      default: {
        return RequestOpenFormTypes.BasicInfo;
      }
    }
  }
}
